import { render } from "./OrderPreparation.vue?vue&type=template&id=2d3dde74"
import script from "./OrderPreparation.vue?vue&type=script&lang=js"
export * from "./OrderPreparation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__